import './Footer.css';
import React, { useState } from 'react';
import FeedbackModal from '../profile/FeedbackModal';

export default function Footer({ onOpenFeedback }) {
    const year = new Date().getFullYear();
    const isStaticMode = process.env.REACT_APP_STATIC_MODE === 'true';


    return (
        <footer className="app-footer" role="contentinfo">
            <div className="app-footer__inner">
                <div className="app-footer__brand">
                    <span className="app-footer__logo">AI Кликер</span>
                    <span className="app-footer__dot">•</span>
                    <span className="app-footer__year">© {year}</span>
                </div>

                <nav aria-label="Правовые ссылки" className="app-footer__nav">
                    <a
                        href="https://storage.yandexcloud.net/ai-clicker.ru/docs/%D0%9F%D0%9E%D0%9B%D0%AC%D0%97%D0%9E%D0%92%D0%90%D0%A2%D0%95%D0%9B%D0%AC%D0%A1%D0%9A%D0%9E%D0%95%20%D0%A1%D0%9E%D0%93%D0%9B%D0%90%D0%A8%D0%95%D0%9D%D0%98%D0%95.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="app-footer__link"
                    >
                        Пользовательское соглашение
                    </a>
                    <a
                        href="https://storage.yandexcloud.net/ai-clicker.ru/docs/%D0%9F%D0%9E%D0%9B%D0%98%D0%A2%D0%98%D0%9A%D0%90%20%D0%9A%D0%9E%D0%9D%D0%A4%D0%98%D0%94%D0%95%D0%9D%D0%A6%D0%98%D0%90%D0%9B%D0%AC%D0%9D%D0%9E%D0%A1%D0%A2%D0%98.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="app-footer__link"
                    >
                        Политика конфиденциальности
                    </a>
                    <a
                        href="https://storage.yandexcloud.net/ai-clicker.ru/docs/%D0%9A%D0%9E%D0%9D%D0%A2%D0%90%D0%9A%D0%A2%D0%AB.pdf"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="app-footer__link"
                    >
                        Контакты
                    </a>

                    {!isStaticMode && (
                        <span
                            className="app-footer__link"
                            style={{ cursor: 'pointer' }}
                            onClick={onOpenFeedback}
                        >
                            Обратная связь
                        </span>
                    )}
                </nav>
            </div>

            <div className="app-footer__bottom">
                Версия приложения v1.0 • Все права защищены
            </div>
        </footer>
    );
}
